import { render, staticRenderFns } from "./UsersModalCommon.vue?vue&type=template&id=470d634a&scoped=true"
import script from "./UsersModalCommon.vue?vue&type=script&lang=js"
export * from "./UsersModalCommon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470d634a",
  null
  
)

export default component.exports